import { ClipboardButton } from '@calendly/clipboard';
import { useBooleanState } from '@calendly/hooks';
import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { ContextualBanner } from '@calendly/ui/components/contextual-banner';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StepControls } from 'features/organization_settings/shared/step';
import { HelpText, Section, SubTitle } from 'features/organization_settings/shared/styles';
import { emailSelector } from 'selectors/current_user';
import { openInNewWindowAuthorizeUrl, testSamlConnection } from '../actions';
import { testSamlSettingsSelector } from '../selectors';
import { setTestSamlSettings } from '../slice';
import { ConfirmExitModal } from './confirm_exit_modal';
import { STEPS } from './constants';
const styledClipboardButtonCss = "s1fn2l5d";
const StyledClipboardButton = forwardRef((props, ref) => <ClipboardButton ref={ref} {...props} className={classNames(styledClipboardButtonCss, props.className)} />);
const copyTextCss = "cl3etd8";
const CopyText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(copyTextCss, props.className)} />;
});
export const TestConnection = ({
  onClose
}) => {
  const dispatch = useDispatch();
  const [isOpen, openModal, closeModal] = useBooleanState(false);
  const email = useSelector(emailSelector);
  const {
    audience_url: audienceUrl,
    acs_url: acsUrl,
    default_relay_state: defaultRelayState,
    test_idp_id: testIdpId
  } = useSelector(testSamlSettingsSelector);
  const onBackClick = () => dispatch(setTestSamlSettings({
    step: STEPS.IDP_INFORMATION
  }));
  const handleCancel = () => openModal();
  const onTestConnectionClick = () => {
    const url = `/users/auth/oktaoauth?state=test&email=${encodeURIComponent(email)}&test_idp_id=${encodeURIComponent(testIdpId)}`;
    dispatch(openInNewWindowAuthorizeUrl(url));
  };
  useEffect(() => {
    const onResponse = ({
      data
    }) => dispatch(testSamlConnection(data, STEPS.APPLY_TEST_SETTINGS));
    window.addEventListener('message', onResponse);
    return () => window.removeEventListener('message', onResponse);
  }, [dispatch]);
  return <>
      <ContextualBanner spacingBottom={24}>
        {I18n.t('publisher.organization_settings.test_saml_settings.test_connection_warning')}
      </ContextualBanner>
      <Section>
        <SubTitle>{I18n.t('publisher.organization_settings.test_saml_settings.connection.audience_url.label')}</SubTitle>
        <HelpText>{I18n.t('publisher.organization_settings.test_saml_settings.connection.audience_url.help_text')}</HelpText>
        <StyledClipboardButton decoration="outline" size="small" content={audienceUrl}>
          {I18n.t('publisher.organization_settings.test_saml_settings.connection.audience_url.copy')}
        </StyledClipboardButton>
        <CopyText>{audienceUrl}</CopyText>
      </Section>
      <Section>
        <SubTitle>{I18n.t('publisher.organization_settings.test_saml_settings.connection.acs_url.label')}</SubTitle>
        <HelpText>{I18n.t('publisher.organization_settings.test_saml_settings.connection.acs_url.help_text')}</HelpText>
        <StyledClipboardButton decoration="outline" size="small" content={acsUrl}>
          {I18n.t('publisher.organization_settings.test_saml_settings.connection.acs_url.copy')}
        </StyledClipboardButton>
        <CopyText>{acsUrl}</CopyText>
      </Section>
      <ContextualBanner spacingTop={16} spacingBottom={16}>
        <SubTitle>{I18n.t('publisher.organization_settings.test_saml_settings.connection.required_attributes.label')}</SubTitle>
        {HtmlParser(I18n.t('publisher.organization_settings.test_saml_settings.connection.required_attributes.message'))}
      </ContextualBanner>
      <Section>
        <SubTitle>{I18n.t('publisher.organization_settings.test_saml_settings.connection.default_relay_state.label')}</SubTitle>
        <HelpText>{I18n.t('publisher.organization_settings.test_saml_settings.connection.default_relay_state.help_text')}</HelpText>
        <StyledClipboardButton decoration="outline" size="small" content={defaultRelayState}>
          {I18n.t('publisher.organization_settings.test_saml_settings.connection.default_relay_state.copy')}
        </StyledClipboardButton>
        <CopyText>{defaultRelayState}</CopyText>
      </Section>
      <ContextualBanner spacingTop={16} spacingBottom={16}>
        {HtmlParser(I18n.t('publisher.organization_settings.test_saml_settings.connection.testing_instructions', {
        email
      }))}
      </ContextualBanner>
      <StepControls>
        <Button decoration="ghost" onClick={onBackClick} aria-label={I18n.t('publisher.action.go_back')}>
          {I18n.t('publisher.action.go_back')}
        </Button>
        <Button decoration="secondary-outline" onClick={handleCancel}>{I18n.t('publisher.action.cancel')}</Button>
        {isOpen && <ConfirmExitModal isOpen={isOpen} onClose={closeModal} onConfirm={onClose} title={I18n.t('publisher.organization_settings.test_saml_settings.confirm_exit_modal')} />}
        <Button onClick={onTestConnectionClick}>
          {I18n.t('publisher.organization_settings.test_saml_settings.connection.test_connection')}
        </Button>
      </StepControls>
    </>;
};

require("./test_connection.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./test_connection.js");